// extracted by mini-css-extract-plugin
export default {"reline":"MainPage_reline__7yzF5","label":"MainPage_label__CjaeP","fileName":"MainPage_fileName__WZDgM","fileOptions":"MainPage_fileOptions__mTtuA"};